import { Box, Pagination } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useGetUser } from '../../hooks/useGetUser'
import {
  getTransactionsByCredentialId
} from '../../redux/actions/transactions.actions'
import { FiltersTransactions } from './filters-transactions'
import { TablePayoneerTransactions } from './table-payoneer-transactions'
import { TablePortalTransactions } from './table-portal-transactions'
import { TableTenuiTransactions } from './table-tenui-transactions'

export const TransactionsContainer = () => {
  // soloVisibles arranca en true: es el comportamiento historico de la
  // pantalla, que oculta los montos por debajo del umbral por activo. El
  // toggle del filtro lo apaga para ver el historial completo.
  const [filters, setFilters] = useState({
    transactionType: 'Portal',
    transactionNumber: '',
    soloVisibles: true,
  })

  const {
    data: transactions,
    isLoading: isLoadingTransactions,
    isError: isErrorTransactions,
    pagination: paginationTransactions,
  } = useSelector((state) => state.transactions)

  const { credentials } = useGetUser()

  const dispatch = useDispatch()

  function handleGetTransactions(newFilters = null, credentialId = null) {
    const baseFilters = newFilters ? newFilters : filters
    const finalFilters = {
      ...baseFilters,
      credentialId,
    }
    console.log(finalFilters)
    if (credentialId) {
      dispatch(getTransactionsByCredentialId(finalFilters))
    }
  }

  useEffect(() => {
    if (credentials?.id) {
      dispatch(getTransactionsByCredentialId({ credentialId: credentials.id }))
    }
  }, [credentials?.id, dispatch])

  return (
    <>
      <FiltersTransactions
        filters={filters}
        setFilters={setFilters}
        handleGetTransactions={handleGetTransactions}
        credentialId={credentials?.id}
      />
      <Box mt={'24px'} overflow={'auto'}>
        {filters.transactionType === 'Portal' ? (
          <TablePortalTransactions
            transactions={transactions}
            isLoadingTransactions={isLoadingTransactions}
            isErrorTransactions={isErrorTransactions}
            credentialId={credentials?.id}
          />
        ) : filters.transactionType === 'Tenui' ? (
          <TableTenuiTransactions
            transactions={transactions}
            isLoadingTransactions={isLoadingTransactions}
            isErrorTransactions={isErrorTransactions}
          />
        ) : (
          <TablePayoneerTransactions
            transactions={transactions}
            isLoadingTransactions={isLoadingTransactions}
            isErrorTransactions={isErrorTransactions}
          />
        )}
      </Box>
      {paginationTransactions?.lastPage > 1 && (
        <Box
          display={'flex'}
          justifyContent={'center'}
          mt={'8px'}
          width={'100%'}
        >
          <Pagination
            count={paginationTransactions?.lastPage}
            page={paginationTransactions?.page}
            onChange={(_, value) => {
              return dispatch(
                getTransactionsByCredentialId({
                  ...filters,
                  credentialId: credentials.id,
                  page: value,
                  withUpdate: false,
                })
              )
            }}
            size="large"
            sx={{ alignSelf: 'center', marginTop: '8px' }}
          />
        </Box>
      )}
    </>
  )
}
